<template>
  <p><slot /></p>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "paragraphBanner",
})
</script>

<style lang="scss" scoped>
p {
  box-sizing: border-box;
  width: 100%;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 16px;
  padding: 16px;
  position: relative;
  font-family: "Montserrat";
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  &::after {
    content: "";
    pointer-events: none;
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 16px;
    background: linear-gradient(135deg, #ffaa00 50.81%, #ff5e00 100%) border-box,
      /* border */ rgba(255, 255, 255, 0.04) padding-box; /* inner */
    -webkit-mask: linear-gradient(#000 0 0) content-box,
      linear-gradient(#000 0 0);
    mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }
}
</style>
